import React, { useState } from 'react';
import Card from '../components/UI/Card';
import { UserIcon, UsersIcon } from '@heroicons/react/24/outline';
import ProfileSettings from '../components/settings/ProfileSettings';
import AdminManagement from '../components/settings/AdminManagement';
import authService from '../api/services/auth.service';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const currentAdmin = authService.getCurrentAdmin();
  const isSuperAdmin = currentAdmin?.role === 'super_admin';

  const tabs = [
    { id: 'profile', label: 'Profile', icon: <UserIcon className="w-5 h-5" /> },
  ];

  if (isSuperAdmin) {
    tabs.push({
      id: 'admins',
      label: 'Admin Management',
      icon: <UsersIcon className="w-5 h-5" />,
    });
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Manage your account and application settings
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <Card className="lg:w-64">
          <div className="space-y-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors
                  ${
                    activeTab === tab.id
                      ? 'bg-primary-500 text-white'
                      : 'hover:bg-gray-50 text-gray-700'
                  }
                `}
              >
                {tab.icon}
                <span className="text-sm font-medium">{tab.label}</span>
              </button>
            ))}
          </div>
        </Card>

        <div className="flex-1">
          {activeTab === 'profile' && <ProfileSettings />}
          {activeTab === 'admins' && isSuperAdmin && <AdminManagement />}
        </div>
      </div>
    </div>
  );
};

export default Settings;